import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/views/Home'
import Checkout from '@/views/Checkout'
import Tracking from '@/views/Tracking'
import Contact from '@/views/Contact'
import Products from '@/views/Products'
import Product from '@/views/Product'
import News from '@/views/News'

Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '*',
			redirect: '/'
		},
		{
			path: '/',
			component: Home
		},
		{
			path: '/news',
			component: News
		},
		{
			path: '/tracking',
			component: Tracking
		},
		{
			path: '/contact',
			component: Contact
		},
		{
			path: '/products',
			component: Products
		},
		{
			path: '/product',
			component: Product
		},
		{
			path: '/checkout',
			component: Checkout
		}
	],
	linkActiveClass: "active",
	mode: "history"
})


// WEBPACK FOOTER //
// ./src/router.js